var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickTransferNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 7.34118,
    fill: "#FF7576"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1542 20.7925C15.1542 23.6147 16.2969 26.3213 18.3309 28.3169C20.3648 30.3125 23.1235 31.4336 26 31.4336C28.8764 31.4336 31.6351 30.3125 33.6691 28.3169C35.703 26.3213 36.8457 23.6147 36.8457 20.7925L26 20.7925L15.1542 20.7925Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5048 34.2085C14.5048 37.1996 15.7159 40.0681 17.8715 42.1831C20.0272 44.2981 22.9509 45.4863 25.9995 45.4863C29.0481 45.4863 31.9718 44.2981 34.1274 42.1831C36.2831 40.0682 37.4941 37.1996 37.4941 34.2086L25.9995 34.2086L14.5048 34.2085Z",
    fill: "#F2F2F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9999,
    cy: 12.6171,
    r: 5.27529,
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickTransferNew);
export default __webpack_public_path__ + "static/media/QuickTransfer_new.9d8c2efa93ac6383d0524e93d74a28f7.svg";
export { ForwardRef as ReactComponent };